import './App.css';
import React from "react";
import {Route, Routes} from "react-router";
import {routes} from "./data/routes";


function App() {

    return (
        <div className="App">
            <Routes>
                {routes.map((route) => (
                    <Route path={route.path} element={ route.element } key={ route.path }/>
                ))}
            </Routes>
        </div>
    );
}

export default App;
